import { ITypeTechnicalRoom } from 'pages/PageTypeTechnicalRoomPprList/interfaces';

export enum EJournalEquipmentStatuses {
  CREATE = 'create',
  ON_AGREEMENT = 'on_agreement',
  REVISION_AGREEMENT = 'revision_agreement',
  AGREEMENT = 'agreement',
}

export enum EJournalEquipmentItemStatuses {
  CHECKED = 1, // Проверено
  ON_CHECK, // На проверке
  WRITTEN_OFF, // Списано
}

export interface IJournalEquipment {
  createUserId: string;

  journalEquipmentId: number;
  areaName: string;
  realEstateName: string;
  journalEquipmentStatusId: EJournalEquipmentStatuses;
  journalEquipmentStatusName: string;

  executorUser?: IUser | null;
  executorUserId?: string;
  executorUserName?: string;
  executorPosition?: IPosition | null;
  executorPositionId?: number;
  executorPositionName?: string;
  executorAgreement: boolean;

  executorHeadUser?: IUser | null;
  executorHeadUserId?: string;
  executorHeadUserName: string;
  executorHeadPosition?: IPosition | null;
  executorHeadPositionId?: number;
  executorHeadPositionName: string;
  executorHeadAgreement: boolean;

  headUser?: IUser | null;
  headUserId?: string;
  headUserName?: string;
  headPosition?: IPosition | null;
  headPositionId?: number;
  headPositionName?: string;
  headAgreement: boolean;

  supervisor?: IUser | null;
  supervisorName?: string;
  supervisorUserId?: string;

  item: IJournalEquipmentItem[];
  modifiedItems: {
    typeTechnicalRoom: ITypeTechnicalRoom | null;
    equipmentTypes: Record<string, IJournalEquipmentItem[]>;
  }[];
  history: IJournalEquipmentHistory[];
}

export interface IJournalEquipmentItem {
  typeTechnicalRoomId?: number;
  typeTechnicalRoomName?: string;
  journalEquipmentItemId?: number;
  journalEquipmentId?: number;
  equipmentType?: IEquipmentType | null;
  equipmentTypeId?: string;
  equipmentTypeName?: string;
  equipment?: IEquipment | null;
  equipmentId?: string;
  equipmentName?: string;
  equipmentCount: number;
  equipmentCountry: string;
  equipmentModel: string;
  equipmentSerialNumberItem?: string;
  equipmentSerialNumber: string[];
  equipmentCost: number;
  dateStart: Date | null;
  monthCount: number;
  comment: string;
  guaranteeMonth: number;
  statusId?: EJournalEquipmentItemStatuses | null;
  statusName?: string | null;
  createAt?: Date;
  createUserId?: string;
  updateAt?: Date;
  updateUserId?: string;
}

export interface IJournalEquipmentHistory {
  journalEquipmentHistoryId: number;
  journalEquipmentId: number;
  agreement: Boolean;
  comment: string;
  createAt: Date;
  createUserId: string;
  createUserName: string;
  journalEquipmentStatusId: EJournalEquipmentStatuses;
  journalEquipmentStatusName: string;
}

export interface IResponsiblePersonList {
  areaId?: number;
  realEstateId?: string;
  executorUser?: IUser | null;
  executorUserId?: string;
  executorPosition?: IPosition | null;
  executorPositionId?: number;
  executorHeadUser?: IUser | null;
  executorHeadUserId?: string;
  executorHeadPosition?: IPosition | null;
  executorHeadPositionId?: number;
  headUser?: IUser | null;
  headUserId?: string;
  headPosition?: IPosition | null;
  headPositionId?: number;
  supervisor?: IUser | null;
  supervisorName?: string;
  supervisorUserId?: string;
}

export interface IEquipment {
  equipmentId?: string;
  equipmentName?: string;
  equipmentSubtypeId?: string;
}

export interface IEquipmentType {
  equipmentTypeId?: string;
  equipmentTypeName?: string;
  isDeleted?: string;
  isDeleted1C?: string;
}

export interface IUser {
  email?: string;
  firstName?: string;
  firstLastName?: string;
  fullName?: string;
  lastName?: string;
  modifyTimestamp?: string;
  telephoneNumber?: string;
  thumbnailPhoto?: string;
  username?: string;
}

export interface IPosition {
  positionId?: number;
  positionName?: string;
}
